import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Label,
  ResponsiveContainer,
} from 'recharts'
import Title from '../Frame/Title'

// Generate Sales Data
const createData = (time, amount) => {
  return { time, amount }
}

const data = [
  createData('00:00', 70),
  createData('03:00', 500),
  createData('06:00', 700),
  createData('09:00', 2200),
  createData('12:00', 30),
  createData('15:00', 350),
  createData('18:00', 1050),
  createData('21:00', 1940),
  createData('24:00', 2023),
]

const Chart = () => {
  const theme = useTheme()

  return (
    <React.Fragment>
      <Title>Günlük Oyuncu Sayısı</Title>
      <ResponsiveContainer>
        <LineChart
          data={data}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <XAxis dataKey='time' stroke={theme.palette.text.secondary}></XAxis>
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position='left'
              style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
            >
              Oyuncu Sayısı
            </Label>
          </YAxis>
          <Line
            type='monotone'
            dataKey='amount'
            stroke={theme.palette.secondary.main}
            dot={false}
            strokeWidth={3}
          />
        </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
  )
}

export default Chart
